import { h } from 'preact';
import NextIcon from './NextIcon';

function PreviousIcon({ height = 60, width = 60 }) {
  return (
    <NextIcon width={width} height={height} style={{ transform: 'scaleX(-1)' }} />
  );
}

export default PreviousIcon;
